import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export default new VueRouter({
  base: __dirname,
  mode: 'history',
  routes: [
    {
      path: '/',
      component: (resolve) => {
        require.ensure(['@/layouts/primary'], () => {
          resolve(require('@/layouts/primary'));
        });
      },
      children: [
        {
          path: '',
          name: 'home',
          component: (resolve) => {
            require.ensure(['@/pages/home'], () => {
              resolve(require('@/pages/home'));
            });
          }
        },

        {
          path: '/about-us',
          name: 'about',
          component: (resolve) => {
            require.ensure(['@/pages/about'], () => {
              resolve(require('@/pages/about'));
            });
          }
        },

        {
          path: '/work',
          name: 'work_index',
          component: (resolve) => {
            require.ensure(['@/pages/work/index'], () => {
              resolve(require('@/pages/work/index'));
            });
          }
        },

        {
          path: '/work/:id',
          name: 'work_show',
          component: (resolve) => {
            require.ensure(['@/pages/work/show'], () => {
              resolve(require('@/pages/work/show'));
            });
          }
        },

        {
          path: '/blog',
          name: 'blog_index',
          component: (resolve) => {
            require.ensure(['@/pages/blog/index'], () => {
              resolve(require('@/pages/blog/index'));
            });
          }
        },

        {
          path: '/blog/:id',
          name: 'blog_detail',
          component: (resolve) => {
            require.ensure(['@/pages/blog/detail'], () => {
              resolve(require('@/pages/blog/detail'));
            });
          }
        },

        {
          path: '/careers',
          name: 'careers_index',
          component: (resolve) => {
            require.ensure(['@/pages/careers/index'], () => {
              resolve(require('@/pages/careers/index'));
            });
          }
        },

        {
          path: '/careers/:id',
          name: 'careers_show',
          component: (resolve) => {
            require.ensure(['@/pages/careers/show'], () => {
              resolve(require('@/pages/careers/show'));
            });
          }
        },

        {
          path: '/contact',
          name: 'contact',
          component: (resolve) => {
            require.ensure(['@/pages/contact'], () => {
              resolve(require('@/pages/contact'));
            });
          }
        },
        {
          path: '/contactform',
          name: 'contact-form',
          component: (resolve) => {
            require.ensure(['@/pages/contact-form'], () => {
              resolve(require('@/pages/contact-form'));
            });
          }
        },
        {
          path: '/contact-thank-you-page',
          name: 'contact-response',
          component: (resolve) => {
            require.ensure(['@/pages/contact-response'], () => {
              resolve(require('@/pages/contact-response'));
            });
          }
        },
        {
          path: '/privacy-policy',
          name: 'privacy_policy',
          component: (resolve) => {
            require.ensure(['@/pages/privacy-policy'], () => {
              resolve(require('@/pages/privacy-policy'));
            });
          }
        }
      ]
    },

    {
      path: '/campaign',
      name: 'campaign_index',
      component: (resolve) => {
        require.ensure(['@/pages/campaign'], () => {
          resolve(require('@/pages/campaign'));
        });
      }
    },

    {
      path: '/campaign/:campaign',
      name: 'campaign_show',
      component: (resolve) => {
        require.ensure(['@/pages/campaign'], () => {
          resolve(require('@/pages/campaign'));
        });
      }
    },

    // Redirects
    {
      path: '/*/about-us',
      redirect: { name: 'about' }
    },

    {
      path: '/*/about-us/*',
      redirect: { name: 'about' }
    },

    {
      path: '/*/contact',
      redirect: { name: 'contact' }
    },

    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }

    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// src/router/index.js